<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="xml_list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="[]"
            :addButton="{ enabled: false }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
        >
        </crud-facecade>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `XmlConfig`,
    data() {
        return {
            title: `单据区域`,
            xmlList: []
        }
    },
    created() {
        this.init()
    },
    computed: {
        ...mapGetters([`enum_menus`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        url() {
            return {
                baseURL: `api/AcisSystem/OperatingWard`,
                get: () => {
                    return new Promise((resolve) => {
                        let req = this.myaxios.get(`/api/AcisSystem/OperatingWard/Get`)
                        let req1 = this.myaxios.get(`/api/AcisSystem/RecoveryWard/Get`)
                        this.myaxios.all(req, req1).then(([data, data1]) => {
                            let o = _.filter(data, { is_deleted: false }).map(d => {
                                return {
                                    id: `${d.id}_1`,
                                    name: d.name,
                                    hospital_ward_name: d.hospital_ward.name,
                                    sys_record_config_id: d.sys_record_config_id,
                                    dic_hosptial_ward_id: d.hospital_ward.id,
                                    allow_select_record_template: d.allow_select_record_template
                                }
                            })
                            let r = _.filter(data1, { is_deleted: false }).map(d => {
                                return {
                                    id: `${d.id}_2`,
                                    name: d.name,
                                    hospital_ward_name: d.hospital_ward.name,
                                    sys_record_config_id: d.sys_record_config_id,
                                    dic_hosptial_ward_id: d.hospital_ward.id,
                                    allow_select_record_template: d.allow_select_record_template
                                }
                            })
                            resolve(o.concat(r))
                        })
                    })
                },
                putMany: (row) => {
                    let data = _.reduce(row, (result, value, key) => {
                        let r = value.id.split(`_`)
                        result.push({
                            id: r[0],
                            sys_record_config_id: value.sys_record_config_id,
                            allow_select_record_template: value.allow_select_record_template,
                            type: r[1]
                        })
                        return result
                    }, [])
                    let result = _.groupBy(data, `type`)
                    if (result[`1`] && result[`1`].length !== 0) {
                        let putData = _.map(result[`1`], (d) => {
                            return {
                                id: d.id,
                                sys_record_config_id: d.sys_record_config_id,
                                allow_select_record_template: d.allow_select_record_template
                            }
                        })
                        let req = this.myaxios.put(`/api/AcisSystem/OperatingWard/PutMany`, putData)
                        req.then(data => {
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                    if (result[`2`] && result[`2`].length !== 0) {
                        let putData = _.map(result[`2`], (d) => {
                            return {
                                id: d.id,
                                sys_record_config_id: d.sys_record_config_id,
                                allow_select_record_template: d.allow_select_record_template
                            }
                        })
                        let req = this.myaxios.put(`/api/AcisSystem/RecoveryWard/PutMany`, putData)
                        req.then(data => {

                        }).catch(e => {
                            console.log(e)
                        })
                    }
                    this.$refs[`xml_list`].ReloadListData()
                }
            }
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `序号`,
                isListable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `dic_hosptial_ward_id`,
                label: `院区id`,
                // isListable: true,
                sortable: true
            }, {
                type: `string`,
                prop: `hospital_ward_name`,
                label: `院区`,
                width: `200`,
                isListable: true
            }, {
                type: `string`,
                prop: `name`,
                label: `区域`,
                width: `200`,
                isListable: true
            }, {
                type: `select`,
                prop: `sys_record_config_id`,
                label: `麻醉单路径`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                options: (that, { row }) => {
                    let r = _.filter(this.xmlList, { is_delete: false })
                    let c = _.filter(this.xmlList, { value: row.sys_record_config_id })
                    return _.uniq(r.concat(c))
                }
            }, {
                type: `bool`,
                prop: `allow_select_record_template`,
                label: `是否允许选择单据`,
                width: `200`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                options: `enum_bool`,
                default: false,
                readonly: false
            }]
        }
    },
    methods: {
        init() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/RecordConfig/Get`)
                req.then(data => {
                    this.xmlList = _.map(data, d => {
                        return {
                            value: d.id,
                            label: d.file_name,
                            is_delete: d.is_delete
                        }
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        SaveShortcutEvent() {

        },
        ExtraButtonClick() {

        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/AnaesthesiaSetting/XmlConfig.vue